import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Auth0Provider } from "@auth0/auth0-react";
import CssBaseline from '@mui/material/CssBaseline';
import { UpdatedPage } from './components/UpdatedPage';

import { ThemeProvider, createTheme } from "@mui/material/styles";

import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";

import './index.css';
import '@fontsource/montserrat';
import { ProtectedRoute } from './ProtectedRoute';
import { MyAccount } from './components/MyAccount';
import { Dashboard } from './components/Dashboard';
import { Organisation } from './components/Organisation';

const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute component={UpdatedPage} />,
  },
  {
    path: 'dashboard',
    element: <ProtectedRoute component={Dashboard} />
  },
  {
    path: "my-account",
    element: <ProtectedRoute component={MyAccount} />
  },
  {
    path: "organization",
    element: <ProtectedRoute component={Organisation} />
  }
]);

const { palette } = createTheme();
const { augmentColor } = palette;

const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const theme = createTheme({
  typography: {
    "fontFamily": `"Inter", "Helvetica", "Arial", sans-serif`,
  },
  palette: {
    mode: 'dark',
    purple: createColor("#8439FF")
  }
});

const MainComponent = () => {
  return (
    <Auth0Provider
      domain="login.deepidentify.ai"
      clientId="iBlbeLz5JiwSdeyjba7qmjQjHag207ru"
      authorizationParams={{redirect_uri: window.location.origin, audience: "https://app.deepidentify.ai/api"}}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
        <ToastContainer />
      </ThemeProvider>
    </Auth0Provider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MainComponent />
  </React.StrictMode>
);
